import axios from 'axios';

export async function search(
  filters: Record<string, unknown>
): Promise<App.Configuration.Data.RegionData[]> {
  return axios.get(route('api.regions.search', filters)).then((res) => res.data);
}
